<template>
  <validation-observer ref="simpleRules">
    <b-form @submit.prevent="validationForm">
      <b-form-group
        label-for="v-user"
        label="User"
      >
        <validation-provider
          #default="{ errors }"
          name="User"
          rules="required"
        >
          <select-data-input
            v-model="user"
            name="user"
            placeholder="Cari nama atau email"
            search-to-load
            custom-option
            :labels-data="['name']"
          >
            <template #option="{ data }">
              <div class="d-flex align-items-center">
                <b-avatar
                  variant="primary"
                  :text="initialText(data.name)"
                  class="align-baseline"
                  :src="linkStaging(data.photo)"
                />
                <div class="ml-1">
                  <div>{{ data.name }}</div>
                  <small class="text-muted">{{ data.email }}</small>
                </div>
              </div>
            </template>
          </select-data-input>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>

      <hr>

      <!-- Bank Name -->
      <b-form-group
        label-for="v-bank_name"
        label="Nama Bank"
      >
        <validation-provider
          #default="{ errors }"
          name="Nama Bank"
          rules="required"
        >
          <b-form-input
            id="v-bank_name"
            v-model="form.bank_name"
            :state="errors.length > 0 ? false : null"
            placeholder="Nama Bank"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>

      <!-- No Rek -->
      <b-form-group
        label-for="v-account_number"
        label="No Rekening"
      >
        <validation-provider
          #default="{ errors }"
          name="No Rekening"
          rules="required"
        >
          <b-form-input
            id="v-account_number"
            v-model="form.account_number"
            :state="errors.length > 0 ? false : null"
            placeholder="No Rekening"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>

      <!-- Atas Nama -->
      <b-form-group
        label-for="v-account_owner"
        label="Nama pemilik rekening"
      >
        <validation-provider
          #default="{ errors }"
          name="Nama pemilik rekening"
          rules="required"
        >
          <b-form-input
            id="v-account_owner"
            v-model="form.account_owner"
            :state="errors.length > 0 ? false : null"
            placeholder="Nama pemilik rekening"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>

      <!-- Branch -->
      <b-form-group
        label-for="v-bank_branch"
        label="Cabang Bank"
      >
        <validation-provider
          #default="{ errors }"
          name="Cabang Bank"
          rules="required"
        >
          <b-form-input
            id="v-bank_branch"
            v-model="form.bank_branch"
            :state="errors.length > 0 ? false : null"
            placeholder="Cabang Bank"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>

      <hr>

      <div class="text-right">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="primary"
          :disabled="!user || isSubmitting"
        >
          <b-spinner
            v-show="isSubmitting"
            small
          />
          Simpan
        </b-button>
      </div>
    </b-form>
  </validation-observer>
</template>

<script>
import { mapActions } from 'vuex'
import {
  BFormGroup,
  BForm,
  BButton,
  BAvatar,
  BSpinner,
  BFormInput,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import SelectDataInput from '../custom/SelectDataInput.vue'

export default {
  components: {
    BFormGroup,
    BForm,
    BAvatar,
    BButton,
    BSpinner,
    BFormInput,

    SelectDataInput,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      user: undefined,
      isSubmitting: false,
      form: {
        bank_name: '',
        account_number: '',
        account_owner: '',
        bank_branch: '',
      },
    }
  },
  methods: {
    ...mapActions('affiliate', ['createAffiliator']),
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.handleSubmit()
        }
      })
    },
    async handleSubmit() {
      this.isSubmitting = true
      await this.createAffiliator({
        user_id: this.user.id,
        ...this.form,
      })
      this.isSubmitting = false
      this.$emit('onSubmit')
    },
  },
}
</script>
